import PropTypes from 'prop-types';

export default function Button({ label, onClick, primary = false, center = false, id = '' }) {
	const classes = ['btn'];
	if (primary) classes.push('btn--primary');
	if (center) classes.push('btn--center');

	return (
		<button className={classes.join(' ')} onClick={onClick} id={id}>
			{label}
		</button>
	);
}

Button.propTypes = {
	label: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	primary: PropTypes.bool,
	center: PropTypes.bool,
	id: PropTypes.string,
};
